import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-grid-system';
import classNames from 'classnames/bind';

import Section from '../Section';
import Video from '../Video';
import Button from '../Button';
import styles from './mediaText.module.scss';

const cx = classNames.bind(styles);

function MediaText(props) {
  const {
    content,
    cta,
    image,
    orientation,
    size,
    title,
    variant,
    video,
  } = props;

  const mediaTextClassName = cx({
    mediaText: true,
    mediaTextPrimary: variant === 'primary',
    mediaTextSecondary: variant === 'secondary',
    mediaTextImageRight: orientation === 'right',
    mediaTextVertical: orientation === 'down',
    mediaTextImageSmall: size === 'small',
  });

  const btnVariant = variant === 'secondary' ? 'secondary' : 'primary';

  const onlyImage = image && !video;
  const onlyVideo = video || (video && image);

  return (
    <div className={mediaTextClassName}>
      <Section>
        <Col sm={12}>
          <div className={styles.wrapper}>
            <div className={styles.mediaContainer}>
              {onlyImage && (
                <img className={styles.image} src={image.file.url} alt={image.file.title} />
              )}
              {onlyVideo && (
                <Video aspectRatio={video.aspectRatio} videoSrc={video.videoUrl} />
              )}

              {(cta && orientation === 'down') && (
                <Button
                  {...cta}
                  modifierclass={styles.btn}
                  link={cta.url}
                  isMobileFull
                  variant={btnVariant}
                >
                  {cta.label}
                </Button>
              )}
            </div>

            <div className={styles.content}>
              {title && (
                <h2 className={styles.title}>{title}</h2>
              )}

              {content && (
                <div dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }} className={styles.text} />
              )}

              {(cta && orientation !== 'down') && (
                <Button
                  {...cta}
                  modifierclass={styles.btn}
                  link={cta.url}
                  isMobileFull
                  variant={btnVariant}
                >
                  {cta.label}
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Section>
    </div>
  );
}

export default MediaText;

MediaText.propTypes = {
  content: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  cta: PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string,
  }),
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    }),
  }),
  orientation: PropTypes.string,
  size: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.string,
  video: PropTypes.shape({
    aspectRatio: PropTypes.string,
    videoUrl: PropTypes.string,
  }),
};

MediaText.defaultProps = {
  content: '',
  cta: null,
  image: '',
  orientation: 'left',
  size: '',
  title: '',
  variant: '',
  video: '',
};
